/* TLV Cart Savings – Expanse (hydration-proof, uses Liquid values) */
(function () {
  function injectStyles() {
    if (document.getElementById("tlv-cart-savings-css")) return;
    const style = document.createElement("style");
    style.id = "tlv-cart-savings-css";
    style.textContent = `
      .tlv-cart-savings{
        margin: 6px 0 8px;
        display: grid;
        gap: 4px;
        text-align: right;
      }
      .tlv-cart-savings__rrp{
        font-size: 13px;
        color: rgba(15,17,21,.55);
        text-decoration: line-through;
      }
      .tlv-cart-savings__save{
        font-size: 13px;
        font-weight: 600;
        color: #b08d57;
      }
    `;
    document.head.appendChild(style);
  }

  function renderCartSavings() {
    // Cart page only
    if (!window.location.pathname.includes("/cart")) return;

    // Get values computed by Liquid (survives hydration)
    const data = window.TLV_CART_SAVINGS && window.TLV_CART_SAVINGS.page;
    if (!data || !data.save) return;

    injectStyles();

    // Prefer our anchor if present, otherwise fallback to subtotal row
    const anchor =
      document.querySelector("[data-tlv-cart-savings-anchor]") ||
      document.querySelector(".cart__item--subtotal");

    if (!anchor) return;

    // Create container once (but if hydration wiped it, recreate)
    let box = document.querySelector(".tlv-cart-savings");
    if (!box) {
      box = document.createElement("div");
      box.className = "tlv-cart-savings";
      box.innerHTML = `
        <div class="tlv-cart-savings__rrp"></div>
        <div class="tlv-cart-savings__save"></div>
      `;

      // If anchor is our empty placeholder div, insert after it.
      // If anchor is subtotal row, insert before subtotal row.
      if (anchor.matches("[data-tlv-cart-savings-anchor]")) {
        anchor.insertAdjacentElement("afterend", box);
      } else {
        anchor.insertAdjacentElement("beforebegin", box);
      }
    }

    box.querySelector(".tlv-cart-savings__rrp").textContent = `RRP ${data.rrp}`;
    box.querySelector(".tlv-cart-savings__save").textContent = `You save ${data.save}`;
    box.style.display = "";
  }

  // Expanse does DOM updates after load; run a few times
  function scheduleRenders() {
    setTimeout(renderCartSavings, 50);
    setTimeout(renderCartSavings, 250);
    setTimeout(renderCartSavings, 700);
    setTimeout(renderCartSavings, 1200);
  }

  document.addEventListener("DOMContentLoaded", scheduleRenders);
  document.addEventListener("page:loaded", scheduleRenders);
  document.addEventListener("change", () => setTimeout(renderCartSavings, 400));
  document.addEventListener("click", () => setTimeout(renderCartSavings, 550));
})();
